import PropTypes from 'prop-types';
import React from 'react';

import { packageLabelToClassName, formatCostInLocaleCurrency, getCoreCostFromSkus } from '~pricing/lib/helpers';
import { RibbonTextOverridePropType } from '~pricing/lib/proptypes';

import PackageHeader from './PackageHeader';

const MonthlyPackageHeader = ({ packageName, skuCosts, details, ribbonText = null }) => {
  const packageClassName = packageLabelToClassName(details);
  const coreSeatCost = getCoreCostFromSkus(skuCosts);
  const formattedMonthlyPrice = formatCostInLocaleCurrency(coreSeatCost);

  return (
    <PackageHeader
      packageClassName={packageClassName}
      packageName={packageName}
      packageLabel={details.displayName.toUpperCase()}
      priceValue={formattedMonthlyPrice}
      priceUnit=" / month"
      ribbonText={ribbonText}
    />
  );
};

MonthlyPackageHeader.propTypes = {
  packageName: PropTypes.string.isRequired,
  details: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  skuCosts: PropTypes.arrayOf(
    PropTypes.shape({
      skuType: PropTypes.string.isRequired,
      cost: PropTypes.number.isRequired,
    })
  ).isRequired,
  ribbonText: RibbonTextOverridePropType,
};

MonthlyPackageHeader.defaultProps = {
  ribbonText: null,
};

export default MonthlyPackageHeader;
